// src/pages/Quotation/QuotationDetailPage.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import UserNavbar from "../../User/UserNavbar";
import UserFooter from "../../User/UserFooter";
import MainSidebar from "../../User/Mainsidebar";
import { loadQuotationDetail, generateInvoice, deleteQuotation } from "../../api/quotationApi";
import QuotationStatusBadge from "../../components/Quotation/QuotationStatusBadge";
import QuotationItemsTable from "../../components/Quotation/QuotationItemsTable";
import QuotationTotalSummary from "../../components/Quotation/QuotationTotalSummary";
import QuotationStatusModal from "../../components/Quotation/QuotationStatusModal";
import QuotationEditModal from "../../components/Quotation/QuotationEditModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const QuotationDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  const [data, setData]                       = useState(null);
  const [loading, setLoading]                 = useState(true);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [showEditModal, setShowEditModal]     = useState(false);

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  const load = async () => {
    setLoading(true);
    try {
      const result = await loadQuotationDetail(id);
      setData(result);
    } catch (e) {
      console.error("Failed to load quotation detail:", e);
      toast.error("Failed to load quotation detail.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [id]);

  const handleGenerateInvoice = async () => {
    if (!window.confirm("Generate invoice from this quotation?")) return;
    try {
      const res = await generateInvoice(id);
      if (res.ok) {
        toast.success("Invoice generated successfully!");
        load();
      } else {
        const err = await res.json().catch(() => ({}));
        toast.error("Failed: " + (err.message || res.status));
      }
    } catch (e) {
      toast.error("Error generating invoice.");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Delete this quotation?")) return;
    try {
      const res = await deleteQuotation(id);
      if (res.ok) {
        toast.success("Quotation deleted.");
        navigate("/quotations");
      } else {
        const err = await res.json().catch(() => ({}));
        toast.error("Failed: " + (err.message || res.status));
      }
    } catch (e) {
      toast.error("Error deleting quotation.");
    }
  };

  const handlePrint = () => {
    window.print();
  };

  const quotation    = data?.quotation;
  const billingList  = Array.isArray(data?.billing)  ? data.billing  : [data?.billing].filter(Boolean);
  const shippingList = Array.isArray(data?.shipping) ? data.shipping : [data?.shipping].filter(Boolean);
  const sellerList   = Array.isArray(data?.seller)   ? data.seller   : [data?.seller].filter(Boolean);
  const itemsList    = Array.isArray(data?.items)    ? data.items    : [];

  return (
    <>
      <div>
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            isRightMenu={isRightMenu}
            setisRightMenu={setisRightMenu}
            handelRightMenuShow={handelRightMenuShow}
            isSearchShow={isSearchShow}
            setIsSearchShow={setIsSearchShow}
            handelShow={handelShow}
            fullScreen={fullScreen}
            setFullScreen={setFullScreen}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
          />
          <ToastContainer />
          <div className="content-wrapper pt-3">
            <section className="content">
              <div className="container-fluid">
                {loading ? (
                  <div className="card shadow-sm border-0 py-5 text-center" style={{ borderRadius: "12px" }}>
                    <i className="fas fa-spinner fa-spin fa-2x mb-3 text-primary d-block" />
                    Loading quotation detail...
                  </div>
                ) : !quotation ? (
                  <div className="card shadow-sm border-0 py-5 text-center" style={{ borderRadius: "12px" }}>
                    <p className="text-danger mb-3">Quotation not found.</p>
                    <div>
                      <button className="btn btn-outline-primary btn-sm" onClick={() => navigate("/quotations")}>
                        ← Back to Quotations
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="invoice p-4 mb-4" style={{ borderRadius: "12px", background: "#fff", boxShadow: "0 4px 12px rgba(0,0,0,0.06)" }}>
                    {/* Header bar */}
                    <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 pb-3 border-bottom mb-4">
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <h3 className="fw-bold text-dark mb-0">{quotation.quoteNumber}</h3>
                          <QuotationStatusBadge status={quotation.status} />
                        </div>
                        <span className="text-muted small">
                          Created Date: {quotation.quoteDate || "—"} | Vendor: {quotation.vendorName || "—"}
                        </span>
                      </div>

                      <div className="d-flex gap-2 flex-wrap no-print">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate("/quotations")}>
                          <i className="fas fa-arrow-left me-1" /> Back
                        </button>
                        <button className="btn btn-outline-dark btn-sm" onClick={handlePrint}>
                          <i className="fas fa-print me-1" /> Print
                        </button>
                        {quotation.status === "DRAFT" && (
                          <button className="btn btn-outline-primary btn-sm" onClick={() => setShowEditModal(true)}>
                            <i className="fas fa-edit me-1" /> Edit
                          </button>
                        )}
                        {["DRAFT", "SENT"].includes(quotation.status) && (
                          <button className="btn btn-outline-info btn-sm" onClick={() => setShowStatusModal(true)}>
                            <i className="fas fa-exchange-alt me-1" /> Change Status
                          </button>
                        )}
                        {quotation.status === "APPROVED" && (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={handleGenerateInvoice}
                            style={{ background: "#059669", borderColor: "#059669" }}
                          >
                            <i className="fas fa-file-invoice me-1" /> Generate Invoice
                          </button>
                        )}
                        {(quotation.status === "DRAFT" || quotation.status === "REJECTED") && (
                          <button className="btn btn-outline-danger btn-sm" onClick={handleDelete}>
                            <i className="fas fa-trash me-1" /> Delete
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Addresses Row */}
                    <div className="row mb-4">
                      {/* Seller */}
                      <div className="col-md-4 mb-3">
                        <div className="card h-100 bg-light border-0 p-3" style={{ borderRadius: "8px" }}>
                          <h6 className="fw-bold text-primary mb-2">Seller Organization</h6>
                          {sellerList.length > 0 ? (
                            sellerList.map((s, i) => (
                              <div key={i} className="small text-secondary">
                                <div className="fw-semibold text-dark">{s.companyName || "Organization"}</div>
                                <div>{s.address}</div>
                                <div>{s.state} {s.country}</div>
                                <div>Phone: {s.phoneNumber || "—"}</div>
                                <div>Email: {s.email || "—"}</div>
                              </div>
                            ))
                          ) : (
                            <span className="small text-muted">No seller record attached.</span>
                          )}
                        </div>
                      </div>

                      {/* Billing Address */}
                      <div className="col-md-4 mb-3">
                        <div className="card h-100 bg-light border-0 p-3" style={{ borderRadius: "8px" }}>
                          <h6 className="fw-bold text-success mb-2">Billing Address</h6>
                          {billingList.length > 0 ? (
                            billingList.map((b, i) => (
                              <div key={i} className="small text-secondary">
                                <div className="fw-semibold text-dark">{b.name || "Client"}</div>
                                <div>{b.Address1 || b.address1}</div>
                                <div>{b.City || b.city}, {b.State || b.state} - {b.Pincode || b.pincode}</div>
                                <div>{b.Country || b.country}</div>
                              </div>
                            ))
                          ) : (
                            <span className="small text-muted">{quotation.billingAddress || "Default billing address"}</span>
                          )}
                        </div>
                      </div>

                      {/* Shipping Address */}
                      <div className="col-md-4 mb-3">
                        <div className="card h-100 bg-light border-0 p-3" style={{ borderRadius: "8px" }}>
                          <h6 className="fw-bold text-secondary mb-2">Shipping Address</h6>
                          {shippingList.length > 0 ? (
                            shippingList.map((s, i) => (
                              <div key={i} className="small text-secondary">
                                <div className="fw-semibold text-dark">{s.name || "Delivery"}</div>
                                <div>{s.address1}</div>
                                <div>{s.city}, {s.state} - {s.pincode}</div>
                                <div>{s.country}</div>
                              </div>
                            ))
                          ) : (
                            <span className="small text-muted">{quotation.shippingAddress || "Same as billing address"}</span>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Items Table */}
                    <div className="mb-4">
                      <h6 className="fw-bold text-dark mb-3">Quotation Line Items</h6>
                      <QuotationItemsTable
                        items={itemsList}
                        editable={quotation.status === "DRAFT"}
                        onItemDeleted={load}
                      />
                    </div>

                    {/* Totals Summary */}
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="card bg-light border-0 p-3" style={{ borderRadius: "8px" }}>
                          <h6 className="fw-bold text-dark mb-2">Notes & Instructions</h6>
                          <p className="small text-muted mb-0" style={{ whiteSpace: "pre-wrap" }}>
                            {quotation.notes || "No special instructions recorded for this quotation."}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <QuotationTotalSummary
                          total={data?.total}
                          quotation={quotation}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </section>
          </div>
          <UserFooter />
        </div>
      </div>

      {showStatusModal && (
        <QuotationStatusModal
          quotation={quotation}
          onClose={() => setShowStatusModal(false)}
          onSuccess={() => {
            toast.success("Status updated successfully.");
            load();
          }}
        />
      )}

      {showEditModal && (
        <QuotationEditModal
          quotation={quotation}
          onClose={() => setShowEditModal(false)}
          onSuccess={() => {
            toast.success("Quotation updated.");
            load();
          }}
        />
      )}
    </>
  );
};

export default QuotationDetailPage;
